// SignUp
import React, { useEffect, useState, useRef } from "react";
import { Footer } from '../components/footer/Footer';

/* Device Agent */
//import "./SignInUpPage.scss";
import useDeviceType from '../utils/getAgent';


function CreateOrgpPage() {
  const [errorMessage, setErrorMessage] = useState("");
  
  const [orgName, setOrgNameState] = useState("");
  const [ownerName, setOwnerNameState] = useState("");
  const [email, setEmailState] = useState("");
  const [url, setUrlState] = useState("");
  const [logo, setLogoState] = useState("");

  const [address1, setAddress1State] = useState("");
  //const [address2, setAddress2State] = useState("");
  const [city1, setCity1State] = useState("");
  const [state1, setState1State] = useState("");
  const [code1, setCode1State] = useState("");
  const [office1, setOffice1State] = useState("");
  const [direct1, setDirect1State] = useState("");

  const [projects, setProjectsState] = useState("");
  const createOrgPic = '/org/gds/wheel.png';
 
   const deviceType = useDeviceType();

 /* Infinite Scolling */
  const containerRef = useRef<HTMLDivElement>(null); // Continuous infinite scroll state - with type

  const [items, setItems] = useState(Array.from({ length: 10 }, (_, i) => `Signup Item ${i + 1}`)); // infinite scrolling items
  const loadMoreItems = () => { 
    setItems(prevItems => [
      ...prevItems,
      ...Array.from({ length: 10 }, (_, i) => `Signup Item ${prevItems.length + i + 1}`)
    ]);
  }; 
  // Hook for loading and scolling items
 useEffect(() => { 
 
     const handleScroll = () => {
     if (!containerRef.current) return;
 
     const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
 

    if (scrollTop + clientHeight >= scrollHeight - 10) {
      loadMoreItems();
    }
    };
 
     const container = containerRef.current;
     if (container) {
       console.log("✅ Scroll to top on load");
       container.addEventListener("scroll", handleScroll, { passive: true })
     }
 
     return () => {
       if (container) {
         container.removeEventListener("scroll", handleScroll);
       }
     };
   }, []); // <-- end of added hook

  /* Infinite Scolling */




  const emailRef = useRef<HTMLInputElement | null>(null);
    
    useEffect(() => {
      if (emailRef.current) {
        emailRef.current.focus();
      }
    }, []);

 
  const handleCreateOrg = (event: { preventDefault: () => void; }) => {
    event.preventDefault();
    if (!orgName) {
      setErrorMessage("Company Name is required.");
      return;
    }

  };

  return (
  
    <div id="pageContainer" className="pageContainer">
      
      
        <div id="createOrgContainer" className={`createOrgContainer ${deviceType}`} ref={containerRef}>
          {/* Error Message Display */}
          {errorMessage && <div className="errorStatus">{errorMessage}</div>}
          <div id="pageImageContainer" className="pageImageContainer">
            <img
              id="createOrgPic"
              className="pagePic"
              src={createOrgPic}
              alt="Company Logo"
            />

         </div>
        
          <div className="signUpTitle">Create Company</div>

          <div className="createOrgInputGroup">
          <input
              className="createOrgInputField"
              type="orgname"
              id="orgname"
              value={orgName}
              onChange={(e) => setOrgNameState(e.target.value)}
              placeholder="Company Name"
          />
          <br/>
          <label className='createOrgLabels' htmlFor="passwordAgain">
              Enter Company Name
          </label>
          </div>

          <div className="createOrgInputGroup">
          <input
              className="createOrgInputField"
              type="ownername"
              id="ownername"
              value={ownerName}
              onChange={(e) => setOwnerNameState(e.target.value)}
              placeholder="Principal's Name"
          />
          <br/>
          <label className='createOrgLabels' htmlFor="passwordAgain">
            Company Owner
          </label>
          </div>

          {/* Owner's Email */}
          <div className="createOrgInputGroup">
          <input
              className="createOrgInputField"
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmailState(e.target.value)}
              placeholder="Principal's Email"
          />
          <br/>
          <label className='createOrgLabels' htmlFor="passwordAgain">
            Owner's Email Address
          </label>
          </div>

          {/* Company Website */}
          <div className="createOrgInputGroup">
            <input
              className="createOrgInputField"  
              type="url"
              id="url"
              value={url}
              onChange={(e) => setUrlState(e.target.value)}
              placeholder="https://www.yourcompany.com"
            />
            
            <br/>
            <label className='createOrgLabels' htmlFor="createOrgInputField">
              Enter Company Website 
            </label>
          </div>
        

          {/* Company Logo Input */}
          <div className="createOrgInputGroup">
          <input
              className="createOrgInputField"  
              type="logo"
              id="logo"
              value={logo}
              onChange={(e) => setLogoState(e.target.value)}
              placeholder="https://www.yourcompany.com/logo.png"
            />
          <br/>
            <label className='createOrgLabels' htmlFor="logo">
              Enter Url to Company logo
            </label>
          </div>


          {/* Address1 Input */}
          <div className="createOrgInputGroup">
            <input
              className="createOrgInputField"
              type="text"
              id="address1"
              value={address1}
              onChange={(e) => setAddress1State(e.target.value)}
              placeholder="Company Address"
            />
            <br/>
            <label className='createOrgLabels' htmlFor="address1">
              Enter Street Address 
            </label>
          </div>

          {/* City1 */}
          <div className="createOrgInputGroup">
            <input
              className="createOrgInputField"
              type="text"
              id="city1"
              value={city1}
              onChange={(e) => setCity1State(e.target.value)}
              placeholder="City"
            />
            <br/>
            <label className='createOrgLabels' htmlFor="city1">
              Enter City 
            </label>
          </div>

          {/* Code 1 */}
          <div className="createOrgInputGroup">
            <input
              className="createOrgInputField"
              type="text"
              id="code1"
              value={code1}
              onChange={(e) => setCode1State(e.target.value)}
              placeholder="Zip Code"
            />
            <br/>
            <label className='createOrgLabels' htmlFor="code1">
              Enter Zip or Postal Code 
            </label>
          </div>

          {/* Office 1 */}
          <div className="createOrgInputGroup">
            <input
              className="createOrgInputField"
              type="text"
              id="office1"
              value={office1}
              onChange={(e) => setCity1State(e.target.value)}
              placeholder="Office Phone"
            />
            <br/>
            <label className='createOrgLabels' htmlFor="office1">
              Enter Office Phone 
            </label>
          </div>

          {/* Direct 1 */}
          <div className="createOrgInputGroup">
            <input
              className="createOrgInputField"
              type="text"
              id="city1"
              value={direct1}
              onChange={(e) => setDirect1State(e.target.value)}
              placeholder="Direct Phone"
            />
            <br/>
            <label className='createOrgLabels' htmlFor="direct1">
              Enter Direct Phone Number
            </label>
          </div>        
          {/* Buttons */}
          <div className="buttonContainer">
            <button className="signUpButton signUpColor" type="button" onClick={() => (window.location.href = "/signup")}>
              Go Back
            </button>
            <button className="signInButton signUpColor" type="submit">Submit</button>
          </div>
        
  
        </div>
     <Footer/>
  </div>


  
  );
}

export default CreateOrgpPage;
